const shell = {
  adminWorkspace: 'Admin workspace',
  brand: {
    admin: 'AI Hub Console',
    user: 'Avaca AI Hub',
  },
  adminNavigation: {
    adminAccounts: 'Admin accounts',
    agent: 'Agent',
    adpCredentials: 'ADP credentials',
    wecomIdentityProfiles: 'WeCom identity sources',
    appEvals: 'App evaluations',
    appReview: 'Publishing review',
    appTags: 'App tags',
    applications: 'Application management',
    apps: 'App list',
    branding: 'Branding',
    businessNavigation: 'Business navigation',
    coreAgent: 'Core Agent',
    conversationLogs: 'Dify conversation logs',
    credentials: 'Credentials',
    idp: 'IDP',
    idpClientScopes: 'Client scopes',
    idpClients: 'Clients',
    idpProvider: 'Provider settings',
    idpResources: 'OAuth resources',
    departments: 'Departments',
    members: 'Members',
    mcp: 'MCP',
    modelCallLogs: 'Call logs',
    modelGateway: 'Model gateway',
    modelKeys: 'Model routing',
    modelProvider: 'Model registry',
    organization: 'Organization',
    organizationSync: 'Sync settings',
    overview: 'Overview',
    settings: 'Settings',
    sso: 'Member authentication',
    statistics: 'Statistics',
    usageDashboard: 'Usage dashboard',
  },
  language: {
    english: 'English',
    simplifiedChinese: '简体中文',
  },
  mobile: {
    closeNavigation: 'Close navigation',
    openNavigation: 'Open navigation',
  },
  sheet: {
    close: 'Close sheet',
  },
  sidebar: {
    collapse: 'Collapse sidebar',
    expand: 'Expand sidebar',
  },
  userNavigation: {
    appSearch: {
      empty: 'Type to search apps',
      label: 'Search apps',
      loading: 'Searching apps',
      noMatches: 'No matching apps',
      placeholder: 'Search apps...',
    },
    appMarket: 'App Center',
    coreAgent: 'Hub Agent',
    history: 'History',
    newChat: 'New chat',
    noQuickApps: 'No apps yet',
    quickApps: 'My apps',
    quickAppsLoading: 'Loading apps',
    recentConversations: 'Recent conversations',
  },
  userMenu: {
    adminProfile: 'Personal settings',
    fallbackName: 'User',
    language: 'Language',
    logout: 'Log out',
    mySettings: 'My settings',
    settings: 'Settings',
    toggle: 'Open user menu',
  },
  workspace: 'Workspace',
}

export default shell
